// added by heliang 20211015 添加供应链
import fetch from '../utils/fetch'

// 获取商品列表
export function getItemsList(query) {
  return fetch({
    url: '/goods/supplychain/goodsList',
    method: 'get',
    params: query
  })
}

// 采集整页商品
export function collectGoodsPage(query) {
  return fetch({
    url: '/goods/supplychain/collectGoodsPage',
    method: 'get',
    params: query
  })
}

// 改变后台同步类型
export function changeSynchType(query) {
  return fetch({
    url: '/goods/supplychain/changeSynchType',
    method: 'get',
    params: query
  })
}

//获取商品分类
export function getCategory(query) {
  return fetch({
    url: '/goods/supplychain/goodsCategory',
    method: 'get',
    params: query
  })
}

//获取商品详情
export function getGoodsDetail(query) {
  return fetch({
    url: '/goods/supplychain/goodsDetail',
    method: 'get',
    params: query
  })
}

//采集商品
export function collectGoods(query) {
  return fetch({
    url: '/goods/supplychain/collectGoods',
    method: 'get',
    params: query
  })
}

//同步库存
export function synchInventory(query) {
  return fetch({
    url: '/goods/supplychain/synchInventory',
    method: 'get',
    params: query
  })
}

//同步商品信息
export function synchGoodsInfo(query) {
  return fetch({
    url: '/goods/supplychain/synchGoodsInfo',
    method: 'get',
    params: query
  })
}
